import * as React from 'react';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';
import { browserHistory } from './../../../App';
import { IAppOnlyStore } from './../../../stores/AllStores';
import { Button, EButtonType } from './../../action';
import { EUserTypeName } from '../../../../../common/interfaces/user';

// Styles
const s = require('./UserDropdown.css');
const padlockIcon = require('./../../../assets/padlock-icon.svg');

// Component
@inject('store')
@observer
export class UserDropdown extends React.Component<IAppOnlyStore, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        const { user } = this.props.store;

        return (
            <CSSTransitionGroup
                className={s.container}
                component="div"
                transitionName="fade"
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}
                transitionAppearTimeout={500}
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}
            >
                {this.props.store.user.showUserDropdown && (
                    <div onClick={this.handleUserDropdownClick} className={s.userDropdown} key="user-dropdown">
                        <ul className={s.links}>
                            {user.userType === EUserTypeName.Portal && (
                                <li>
                                    <Button onClick={this.handleOrdersHistoryButtonClick}>Orders history</Button>
                                </li>
                            )}
                            {user.userType === EUserTypeName.Portal && (
                                <li>
                                    <Button onClick={this.handleWarehousesLocationsButtonClick}>
                                        {user.customerIsPAC
                                            ? 'PAC locations'
                                            : user.customerIsPBI ? 'PBI locations' : 'Locations'}
                                    </Button>
                                </li>
                            )}
                            <li>
                                <Button onClick={this.handleOpeningOfChangePasswordModal}>Change password</Button>
                            </li>
                        </ul>

                        {user.userType === EUserTypeName.Portal &&
                            user.customerPaymentTerms && (
                                <div className={s.paymentTerms}>
                                    <p className={s.label}>Payment terms:</p>
                                    <p className={s.value}>{user.customerPaymentTerms}</p>
                                </div>
                            )}

                        <Button
                            className={s.logout}
                            onClick={this.handleLogout}
                            type={EButtonType.Important}
                            icon={{
                                element: <img src={padlockIcon} width={12} height={16} />,
                                onLeft: false
                            }}
                        >
                            Logout
                        </Button>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }

    private handleUserDropdownClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    @action
    private handleOrdersHistoryButtonClick = () => {
        this.props.store.user.showUserDropdown = false;
        this.props.store.orders.openOrdersHistoryModal();
    };

    @action
    private handleWarehousesLocationsButtonClick = () => {
        this.props.store.user.showUserDropdown = false;
        this.props.store.warehouse.showWarehousesLocations = true;
    };

    @action
    private handleOpeningOfChangePasswordModal = () => {
        this.props.store.user.showUserDropdown = false;
        this.props.store.changePassword.openChangePasswordModal();
    };

    @action
    private handleLogout = () => {
        this.props.store.user.showUserDropdown = false;
        browserHistory.push('/user/logout');
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/UserDropdown/UserDropdown.tsx